import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';

const lbl = { fontSize:12, color:'#64748B', display:'block', marginBottom:3, fontWeight:600 };
const inp = { border:'1px solid #E2E8F0', borderRadius:6, padding:'7px 10px', width:'100%',
  fontSize:13, boxSizing:'border-box', fontFamily:'inherit' };
const lockedStyle = { ...inp, background:'#F8FAFC', color:'#94A3B8', border:'1px solid #F1F5F9' };

const EMPTY_DIRIGEANT  = { nom:'', formations:'', annees_exp:'', pct_capital:'', sauvegarde:'non', redressement:'non', liquidation:'non' };
const EMPTY_PATRIMOINE = { nom_dirigeant:'', type_immobilier:'', adresse_immo:'', type_mobilier:'', estimation:'', prets:'', etablissement:'', capital_investi:'' };
const EMPTY_SOCIETE    = { nom:'', associe:'', siren:'', date_creation:'', ca_n1:'', resultat_n1:'' };
const N_PREVISIONNEL   = 12; // 12 mois max

// Compute next N months from a YYYY-MM string
function computeMonths(firstMonth, n) {
  if (!firstMonth || !firstMonth.includes('-')) return Array(n).fill('');
  const parts = firstMonth.split('-');
  const year = parseInt(parts[0]); const month = parseInt(parts[1]);
  if (isNaN(year) || isNaN(month)) return Array(n).fill('');
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(year, month - 1 + i, 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    return `${y}-${m}`;
  });
}

function Section({ label }) {
  return (
    <div style={{ fontSize:13, fontWeight:800, color:'#E8671A', textTransform:'uppercase',
      letterSpacing:'.06em', paddingBottom:6, borderBottom:'2px solid #E8671A', marginBottom:14, marginTop:22 }}>
      {label}
    </div>
  );
}
function Grid({ cols, children, gap=10, mt=0 }) {
  return <div style={{ display:'grid', gridTemplateColumns:`repeat(${cols},1fr)`, gap, marginBottom:10, marginTop:mt }}>{children}</div>;
}
function F({ label, value, onChange, placeholder='', type='text', rows, readOnly }) {
  const s = readOnly ? lockedStyle : inp;
  if (rows) return (
    <div>
      {label && <label style={lbl}>{label}</label>}
      <textarea value={value||''} onChange={onChange} placeholder={placeholder} rows={rows}
        style={{...s,resize:'vertical'}} readOnly={readOnly}/>
    </div>
  );
  return (
    <div>
      {label && <label style={lbl}>{label}</label>}
      <input type={type} value={value||''} onChange={onChange} placeholder={placeholder}
        style={s} readOnly={readOnly}/>
    </div>
  );
}
function YN({ label, value, onChange, disabled }) {
  return (
    <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:4 }}>
      <span style={{ fontSize:12,color:'#475569',flex:1 }}>{label}</span>
      {['oui','non'].map(v => (
        <label key={v} style={{ display:'flex',alignItems:'center',gap:4,cursor:disabled?'default':'pointer',fontSize:12 }}>
          <input type="radio" checked={value===v} onChange={() => !disabled && onChange(v)}
            disabled={disabled} style={{ accentColor:'#E8671A' }}/>
          {v==='oui'?'Oui':'Non'}
        </label>
      ))}
    </div>
  );
}


const MONTHS_FR = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Août','Sep','Oct','Nov','Déc'];
const MONTHS_EN = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function MonthPicker({ value, onChange, disabled, highlight }) {
  const [open, setOpen] = React.useState(false);
  const [pickerYear, setPickerYear] = React.useState(() => {
    if (value && value.includes('-')) return parseInt(value.split('-')[0]) || new Date().getFullYear();
    return new Date().getFullYear();
  });
  const ref = React.useRef(null);

  // Close on outside click
  React.useEffect(() => {
    if (!open) return;
    function handle(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [open]);

  // Parse stored value YYYY-MM
  let selYear = null, selMonth = null;
  if (value && value.includes('-')) {
    const parts = value.split('-');
    const y = parseInt(parts[0]); const m = parseInt(parts[1]);
    if (!isNaN(y) && !isNaN(m)) { selYear = y; selMonth = m; }
  }

  // Display label
  const displayLabel = selYear && selMonth
    ? `${String(selMonth).padStart(2,'0')}/${selYear}`
    : null;

  function handleSelect(monthIdx) {
    const m = String(monthIdx + 1).padStart(2, '0');
    onChange(`${pickerYear}-${m}`);
    setOpen(false);
  }

  return (
    <div ref={ref} style={{ position:'relative' }}>
      <button type="button"
        onClick={() => { if (!disabled) { setOpen(o => !o); if (selYear) setPickerYear(selYear); }}}
        disabled={disabled}
        style={{
          width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between',
          padding:'7px 10px', borderRadius:6, cursor:disabled?'default':'pointer',
          border:`1.5px solid ${highlight?'#E8671A':open?'#2563EB':'#E2E8F0'}`,
          background: highlight ? '#FFF7F2' : '#fff',
          fontSize:13, fontFamily:'inherit', color: displayLabel ? '#1A1A1A' : '#94A3B8',
        }}>
        <span>{displayLabel || '— mois / année —'}</span>
        <span style={{ fontSize:14 }}>📅</span>
      </button>

      {open && (
        <div style={{
          position:'absolute', top:'calc(100% + 4px)', left:0, zIndex:9999,
          background:'#fff', border:'1px solid #E2E8F0', borderRadius:10,
          padding:14, boxShadow:'0 8px 32px rgba(0,0,0,.18)', width:220,
        }}>
          {/* Navigation année */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
            marginBottom:12, background:'#F8FAFC', borderRadius:7, padding:'6px 10px' }}>
            <button type="button" onClick={() => setPickerYear(y => y-1)}
              style={{ background:'none', border:'none', cursor:'pointer', fontSize:16, padding:'0 4px', color:'#64748B' }}>
              ‹
            </button>
            <span style={{ fontSize:14, fontWeight:700 }}>{pickerYear}</span>
            <button type="button" onClick={() => setPickerYear(y => y+1)}
              style={{ background:'none', border:'none', cursor:'pointer', fontSize:16, padding:'0 4px', color:'#64748B' }}>
              ›
            </button>
          </div>

          {/* Grille mois */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:5 }}>
            {MONTHS_FR.map((m, idx) => {
              const isSelected = selYear === pickerYear && selMonth === idx+1;
              return (
                <button key={idx} type="button" onClick={() => handleSelect(idx)}
                  style={{
                    padding:'7px 4px', borderRadius:7, cursor:'pointer', fontSize:12,
                    fontWeight: isSelected ? 800 : 400,
                    background: isSelected ? '#E8671A' : '#F8FAFC',
                    color: isSelected ? '#fff' : '#475569',
                    border: isSelected ? 'none' : '1px solid #E2E8F0',
                  }}>
                  {m}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default function CollecteInfoGF({ data, onChange, readOnly: roProp }) {
  const { t } = useLanguage();
  const { isCourtier } = useAuth();
  const readOnly = roProp;

  const set = key => e => onChange({ ...data, [key]: e.target.value });
  const setV = (key, val) => onChange({ ...data, [key]: val });

  // Dirigeants
  const dirigeants = data.dirigeants || [{ ...EMPTY_DIRIGEANT }];
  const setDir = (i, k, v) => { const a=[...dirigeants]; a[i]={...a[i],[k]:v}; setV('dirigeants',a); };

  // Patrimoines
  const patrimoines = data.patrimoines || [{ ...EMPTY_PATRIMOINE }];
  const setPat = (i, k, v) => { const a=[...patrimoines]; a[i]={...a[i],[k]:v}; setV('patrimoines',a); };

  // Sociétés
  const societes = data.societes || [{ ...EMPTY_SOCIETE }];
  const setSoc = (i, k, v) => { const a=[...societes]; a[i]={...a[i],[k]:v}; setV('societes',a); };

  // Prévisionnel — 12 lignes max avec auto-remplissage mois
  const rawPrev = data.previsionnel || [];
  const previsionnel = Array.from({ length: N_PREVISIONNEL }, (_, i) => {
    const r = rawPrev[i] || {};
    // Sanitize: ignore NaN or invalid month values
    const p = r.periode && r.periode.includes('-') && !r.periode.includes('NaN') ? r.periode : '';
    return { periode: p, montant: r.montant || '' };
  });
  const setPrevMontant = (i, v) => {
    const a = [...previsionnel]; a[i]={...a[i],montant:v}; setV('previsionnel',a);
  };
  const handleFirstMonth = val => {
    const months = computeMonths(val, N_PREVISIONNEL);
    const a = previsionnel.map((row, i) => ({ ...row, periode: months[i] || '' }));
    setV('previsionnel', a);
  };
  const totalPrev = previsionnel.reduce((s, r) => s + (parseFloat(r.montant)||0), 0);

  return (
    <div style={{ fontSize:13 }}>
      {/* Header */}
      <div style={{ background:'#FFF7F2',border:'1px solid #FED7AA',borderRadius:8,
        padding:'10px 14px',marginBottom:18,display:'flex',gap:10,alignItems:'flex-start' }}>
        <span style={{ fontSize:18 }}>📋</span>
        <div>
          <div style={{ fontWeight:700,color:'#92400E' }}>{t('collecte.title')}</div>
          <div style={{ fontSize:12,color:'#92400E',marginTop:2 }}>{t('collecte.dr_ref')}</div>
        </div>
      </div>

      {/* ── 1. RENSEIGNEMENTS GÉNÉRAUX ─────────────────────── */}
      <Section label={t('collecte.section_renseignements')}/>
      <Grid cols={2}>
        <F label={t('collecte.nom_social')} value={data.nom_social} onChange={set('nom_social')} readOnly={readOnly}/>
        <F label={t('collecte.nom_commercial')} value={data.nom_commercial} onChange={set('nom_commercial')} readOnly={readOnly}/>
      </Grid>
      <Grid cols={2}>
        <F label={t('collecte.directeur')} value={data.directeur} onChange={set('directeur')} readOnly={readOnly}/>
        <F label={t('collecte.adresse')} value={data.adresse} onChange={set('adresse')} readOnly={readOnly}/>
      </Grid>
      <Grid cols={3}>
        <F label={t('intermediaires.postal_code')} value={data.code_postal} onChange={set('code_postal')} readOnly={readOnly}/>
        <F label={t('intermediaires.city')} value={data.ville} onChange={set('ville')} readOnly={readOnly}/>
        <F label={t('collecte.forme_juridique')} value={data.forme_juridique} onChange={set('forme_juridique')} readOnly={readOnly}/>
      </Grid>
      <Grid cols={3}>
        <F label={t('collecte.capital_social')} value={data.capital_social} onChange={set('capital_social')} placeholder="Ex. 10 000 €" readOnly={readOnly}/>
        <F label={t('collecte.siren')} value={data.siren} onChange={set('siren')} placeholder="Ex. 853 774 529" readOnly={readOnly}/>
        <F label={t('collecte.site_internet')} value={data.site_internet} onChange={set('site_internet')} placeholder="www..." readOnly={readOnly}/>
      </Grid>
      <Grid cols={3}>
        <F label={t('intermediaires.phone')} value={data.telephone} onChange={set('telephone')} type="tel" readOnly={readOnly}/>
        <F label={t('intermediaires.email')} value={data.email} onChange={set('email')} type="email" readOnly={readOnly}/>
        <F label={t('collecte.date_creation')} value={data.date_creation} onChange={set('date_creation')} type="date" readOnly={readOnly}/>
      </Grid>
      <Grid cols={3}>
        <F label={t('collecte.date_cloture')} value={data.date_cloture} onChange={set('date_cloture')} placeholder="Ex. 31/12" readOnly={readOnly}/>
        <F label={t('collecte.nb_agences')} value={data.nb_agences} onChange={set('nb_agences')} type="number" readOnly={readOnly}/>
        <F label={t('collecte.nb_collaborateurs')} value={data.nb_collaborateurs} onChange={set('nb_collaborateurs')} type="number" readOnly={readOnly}/>
      </Grid>
      <Grid cols={2}>
        <F label={t('collecte.immat_atout_france')} value={data.immat_atout_france} onChange={set('immat_atout_france')} readOnly={readOnly}/>
        <F label={t('collecte.rc_pro_numero')} value={data.rc_pro_numero} onChange={set('rc_pro_numero')} readOnly={readOnly}/>
      </Grid>
      <Grid cols={2}>
        <div>
          <label style={lbl}>{t('collecte.rc_pro_compagnie')}</label>
          {readOnly
            ? <div style={lockedStyle}>{data.rc_pro_compagnie||'—'}</div>
            : <select value={data.rc_pro_compagnie||''} onChange={set('rc_pro_compagnie')} style={inp}>
                <option value="">—</option>
                {['Hiscox','MMA','Generali','Helvetia','Allianz','AXA','Autre'].map(c=>(
                  <option key={c}>{c}</option>
                ))}
              </select>
          }
        </div>
        <F label={t('collecte.rc_pro_echeance')} value={data.rc_pro_echeance} onChange={set('rc_pro_echeance')} type="date" readOnly={readOnly}/>
      </Grid>

      {/* Banque */}
      <div style={{ background:'#F8FAFC',borderRadius:7,padding:'10px 14px',marginBottom:10 }}>
        <div style={{ fontSize:11,fontWeight:700,color:'#64748B',marginBottom:8,textTransform:'uppercase' }}>
          {t('collecte.banque_title')}
        </div>
        <Grid cols={3}>
          <F label={t('collecte.banque_title')} value={data.banque} onChange={set('banque')} readOnly={readOnly}/>
          <F label={t('collecte.correspondant')} value={data.banque_correspondant} onChange={set('banque_correspondant')} readOnly={readOnly}/>
          <F label={t('intermediaires.phone')} value={data.banque_tel} onChange={set('banque_tel')} type="tel" readOnly={readOnly}/>
        </Grid>
        <Grid cols={2}>
          <F label={t('intermediaires.email')} value={data.banque_email} onChange={set('banque_email')} type="email" readOnly={readOnly}/>
        </Grid>
      </div>

      {/* Expert-comptable */}
      <div style={{ background:'#F8FAFC',borderRadius:7,padding:'10px 14px',marginBottom:10 }}>
        <div style={{ fontSize:11,fontWeight:700,color:'#64748B',marginBottom:8,textTransform:'uppercase' }}>
          {t('collecte.ec_title')}
        </div>
        <Grid cols={3}>
          <F label={t('collecte.ec_title')} value={data.expert_comptable} onChange={set('expert_comptable')} readOnly={readOnly}/>
          <F label={t('collecte.correspondant')} value={data.ec_correspondant} onChange={set('ec_correspondant')} readOnly={readOnly}/>
          <F label={t('intermediaires.phone')} value={data.ec_tel} onChange={set('ec_tel')} type="tel" readOnly={readOnly}/>
        </Grid>
        <Grid cols={2}>
          <F label={t('intermediaires.email')} value={data.ec_email} onChange={set('ec_email')} type="email" readOnly={readOnly}/>
        </Grid>
      </div>

      {/* ── 2. DIRIGEANTS ──────────────────────────────────── */}
      <Section label={t('collecte.section_dirigeants')}/>
      {dirigeants.map((d, i) => (
        <div key={i} style={{ border:'1px solid #E2E8F0',borderRadius:8,padding:12,marginBottom:10 }}>
          <div style={{ display:'flex',justifyContent:'space-between',marginBottom:8 }}>
            <span style={{ fontSize:12,fontWeight:700,color:'#64748B' }}>{t('collecte.dir_num')} {i+1}</span>
            {!readOnly && i>0 && <button onClick={() => setV('dirigeants', dirigeants.filter((_,ix)=>ix!==i))}
              style={{ fontSize:11,color:'#DC2626',background:'none',border:'none',cursor:'pointer' }}>{t('collecte.dir_del')}</button>}
          </div>
          <Grid cols={2}>
            <F label={t('collecte.dir_nom')} value={d.nom} onChange={e=>setDir(i,'nom',e.target.value)} readOnly={readOnly}/>
            <F label={t('collecte.dir_formations')} value={d.formations} onChange={e=>setDir(i,'formations',e.target.value)} readOnly={readOnly}/>
          </Grid>
          <Grid cols={2}>
            <F label={t('collecte.dir_annees')} value={d.annees_exp} onChange={e=>setDir(i,'annees_exp',e.target.value)} type="number" readOnly={readOnly}/>
            <F label={t('collecte.dir_pct')} value={d.pct_capital} onChange={e=>setDir(i,'pct_capital',e.target.value)} placeholder="Ex. 50" readOnly={readOnly}/>
          </Grid>
          <div style={{ background:'#FFF5F5',borderRadius:6,padding:'8px 12px',marginTop:6 }}>
            <div style={{ fontSize:11,fontWeight:700,color:'#991B1B',marginBottom:6 }}>{t('collecte.dir_situations')}</div>
            <YN label={t('collecte.dir_sauvegarde')} value={d.sauvegarde} onChange={v=>setDir(i,'sauvegarde',v)} disabled={readOnly}/>
            <YN label={t('collecte.dir_redressement')} value={d.redressement} onChange={v=>setDir(i,'redressement',v)} disabled={readOnly}/>
            <YN label={t('collecte.dir_liquidation')} value={d.liquidation} onChange={v=>setDir(i,'liquidation',v)} disabled={readOnly}/>
          </div>
        </div>
      ))}
      {!readOnly && dirigeants.length < 4 && (
        <button onClick={() => setV('dirigeants',[...dirigeants,{...EMPTY_DIRIGEANT}])}
          style={{ fontSize:13,color:'#2563EB',background:'none',border:'1px dashed #93C5FD',borderRadius:7,padding:'8px',cursor:'pointer',width:'100%',marginBottom:8 }}>
          {t('collecte.dir_add')}
        </button>
      )}
      <F label={t('collecte.dir_infos')} value={data.infos_importantes} onChange={set('infos_importantes')} rows={3} readOnly={readOnly}/>

      {/* ── 3. PATRIMOINE ──────────────────────────────────── */}
      <Section label={t('collecte.section_patrimoine')}/>
      {patrimoines.map((p, i) => (
        <div key={i} style={{ border:'1px solid #E2E8F0',borderRadius:8,padding:12,marginBottom:10 }}>
          <div style={{ fontSize:12,fontWeight:700,color:'#64748B',marginBottom:8 }}>{t('collecte.dir_num')} {i+1}</div>
          <Grid cols={2}>
            <F label={t('collecte.pat_nom')} value={p.nom_dirigeant} onChange={e=>setPat(i,'nom_dirigeant',e.target.value)} readOnly={readOnly}/>
            <F label={t('collecte.pat_estimation')} value={p.estimation} onChange={e=>setPat(i,'estimation',e.target.value)} type="number" readOnly={readOnly}/>
          </Grid>
          <Grid cols={2}>
            <div>
              <label style={lbl}>{t('collecte.pat_type_immo')}</label>
              <select value={p.type_immobilier||''} onChange={e=>setPat(i,'type_immobilier',e.target.value)}
                style={readOnly?lockedStyle:inp} disabled={readOnly}>
                <option value="">—</option>
                <option>Maison</option>
                <option>Appartement</option>
                <option>Autre</option>
              </select>
            </div>
            <F label={t('collecte.pat_adresse_immo')} value={p.adresse_immo} onChange={e=>setPat(i,'adresse_immo',e.target.value)} readOnly={readOnly}/>
          </Grid>
          <Grid cols={2}>
            <div>
              <label style={lbl}>{t('collecte.pat_type_mobilier')}</label>
              <select value={p.type_mobilier||''} onChange={e=>setPat(i,'type_mobilier',e.target.value)}
                style={readOnly?lockedStyle:inp} disabled={readOnly}>
                <option value="">—</option>
                <option>Placement</option><option>Épargne</option>
                <option>Assurance-vie</option><option>Autre</option>
              </select>
            </div>
            <F label={t('collecte.pat_prets')} value={p.prets} onChange={e=>setPat(i,'prets',e.target.value)} type="number" readOnly={readOnly}/>
          </Grid>
          <Grid cols={2}>
            <F label={t('collecte.pat_etablissement')} value={p.etablissement} onChange={e=>setPat(i,'etablissement',e.target.value)} readOnly={readOnly}/>
            <F label={t('collecte.pat_capital')} value={p.capital_investi} onChange={e=>setPat(i,'capital_investi',e.target.value)} type="number" readOnly={readOnly}/>
          </Grid>
        </div>
      ))}
      {!readOnly && patrimoines.length < 4 && (
        <button onClick={() => setV('patrimoines',[...patrimoines,{...EMPTY_PATRIMOINE}])}
          style={{ fontSize:13,color:'#2563EB',background:'none',border:'1px dashed #93C5FD',borderRadius:7,padding:'8px',cursor:'pointer',width:'100%',marginBottom:8 }}>
          {t('collecte.pat_add')}
        </button>
      )}

      {/* ── 4. AUTRES SOCIÉTÉS ─────────────────────────────── */}
      <Section label={t('collecte.section_societes')}/>
      <div style={{ background:'#FEF3C7',borderRadius:6,padding:'8px 12px',fontSize:12,color:'#92400E',marginBottom:12 }}>
        ⚠ {t('collecte.soc_warning')}
      </div>
      <div style={{ border:'1px solid #E2E8F0',borderRadius:8,overflow:'hidden',marginBottom:12 }}>
        <div style={{ display:'grid',gridTemplateColumns:'2fr 1.5fr 1fr 1fr 1fr 1fr',
          background:'#F8FAFC',padding:'8px 10px',fontSize:11,fontWeight:700,color:'#64748B' }}>
          <div>{t('collecte.soc_nom')}</div><div>{t('collecte.soc_associe')}</div>
          <div>SIREN</div><div>{t('collecte.soc_date')}</div>
          <div>{t('collecte.soc_ca')}</div><div>{t('collecte.soc_resultat')}</div>
        </div>
        {societes.map((s, i) => (
          <div key={i} style={{ display:'grid',gridTemplateColumns:'2fr 1.5fr 1fr 1fr 1fr 1fr',
            gap:6,padding:'8px 10px',borderTop:'1px solid #F1F5F9' }}>
            {['nom','associe','siren'].map(k => (
              <input key={k} value={s[k]||''} onChange={e=>setSoc(i,k,e.target.value)}
                style={readOnly?lockedStyle:{...inp,padding:'5px 8px'}} readOnly={readOnly}/>
            ))}
            <input type="date" value={s.date_creation||''} onChange={e=>setSoc(i,'date_creation',e.target.value)}
              style={readOnly?lockedStyle:{...inp,padding:'5px 8px'}} readOnly={readOnly}/>
            {['ca_n1','resultat_n1'].map(k => (
              <input key={k} type="number" value={s[k]||''} onChange={e=>setSoc(i,k,e.target.value)}
                style={readOnly?lockedStyle:{...inp,padding:'5px 8px'}} readOnly={readOnly}/>
            ))}
          </div>
        ))}
      </div>
      {!readOnly && societes.length < 4 && (
        <button onClick={() => setV('societes',[...societes,{...EMPTY_SOCIETE}])}
          style={{ fontSize:13,color:'#2563EB',background:'none',border:'1px dashed #93C5FD',borderRadius:7,padding:'8px',cursor:'pointer',width:'100%',marginBottom:8 }}>
          {t('collecte.soc_add')}
        </button>
      )}

      {/* ── 5. PRÉSENTATION ────────────────────────────────── */}
      <Section label={t('collecte.section_presentation')}/>
      <F label={t('collecte.description_label')} value={data.description_activite}
        onChange={set('description_activite')} rows={4} readOnly={readOnly}
        placeholder={t('collecte.description_placeholder')}/>
      <div style={{ marginTop:10 }}>
        <F label={t('collecte.reseau_label')} value={data.reseau}
          onChange={set('reseau')} readOnly={readOnly} placeholder={t('collecte.reseau_placeholder')}/>
      </div>

      {/* CA */}
      <div style={{ border:'1px solid #E2E8F0',borderRadius:8,overflow:'hidden',marginTop:14,marginBottom:12 }}>
        <div style={{ background:'#F8FAFC',padding:'10px 14px',fontSize:12,fontWeight:700,
          color:'#475569',textTransform:'uppercase',letterSpacing:'.04em',borderBottom:'1px solid #E2E8F0' }}>
          {t('collecte.ca_title')}
        </div>
        {[
          [t('collecte.ca_forfaits_dist'), 'ca_forfaits_distribution'],
          [t('collecte.ca_forfaits_prod'), 'ca_forfaits_production'],
          [t('collecte.ca_prestations'),   'ca_prestations'],
          [t('collecte.ca_transport'),     'ca_transport'],
        ].map(([label, key]) => (
          <div key={key} style={{ display:'grid',gridTemplateColumns:'1fr 200px',alignItems:'center',
            padding:'10px 14px',borderBottom:'1px solid #F1F5F9' }}>
            <label style={{ fontSize:13,color:'#475569' }}>{label}</label>
            <input type="number" value={data[key]||''} onChange={set(key)} placeholder="0"
              readOnly={readOnly}
              style={readOnly?{...lockedStyle,textAlign:'right'}:{...inp,textAlign:'right'}}/>
          </div>
        ))}
        {/* Total en vert */}
        <div style={{ display:'grid',gridTemplateColumns:'1fr 200px',alignItems:'center',
          padding:'12px 14px',background:'#D1FAE5',borderTop:'2px solid #6EE7B7' }}>
          <span style={{ fontSize:14,fontWeight:800,color:'#065F46' }}>{t('collecte.ca_total')}</span>
          <div style={{ fontSize:16,fontWeight:800,color:'#059669',textAlign:'right',
            background:'#A7F3D0',borderRadius:6,padding:'6px 10px' }}>
            {[data.ca_forfaits_distribution,data.ca_forfaits_production,
              data.ca_prestations,data.ca_transport]
              .map(v=>parseFloat(v)||0).reduce((a,b)=>a+b,0)
              .toLocaleString('fr-FR')} €
          </div>
        </div>
      </div>

      <Grid cols={2}>
        <F label={t('collecte.clientele_btoc')} value={data.clientele_btoc} onChange={set('clientele_btoc')} placeholder="Ex. 80%" readOnly={readOnly}/>
        <F label={t('collecte.clientele_btob')} value={data.clientele_btob} onChange={set('clientele_btob')} placeholder="Ex. 20%" readOnly={readOnly}/>
      </Grid>
      <Grid cols={2}>
        <F label={t('collecte.clientele_autres')} value={data.clientele_autres} onChange={set('clientele_autres')} readOnly={readOnly}/>
        <F label={t('collecte.mode_distrib')} value={data.mode_distribution} onChange={set('mode_distribution')} readOnly={readOnly}/>
      </Grid>
      <F label={t('collecte.fournisseurs_label')} value={data.fournisseurs}
        onChange={set('fournisseurs')} rows={2} readOnly={readOnly}
        placeholder={t('collecte.fournisseurs_placeholder')}/>

      {/* ── 6. COMPLÉMENTS ─────────────────────────────────── */}
      <Section label={t('collecte.section_complement')}/>
      <F label={t('collecte.engagement_label')} value={data.engagement_volume} onChange={set('engagement_volume')} rows={2} readOnly={readOnly}/>
      <div style={{ marginTop:10,marginBottom:10 }}>
        <F label={t('collecte.delais_label')} value={data.delais_reglement} onChange={set('delais_reglement')} rows={2} readOnly={readOnly}/>
      </div>

      <div style={{ background:'#F8FAFC',borderRadius:8,padding:'12px 14px',marginBottom:12 }}>
        <div style={{ fontSize:12,fontWeight:700,color:'#475569',marginBottom:10,textTransform:'uppercase',letterSpacing:'.04em' }}>
          {t('collecte.repartition_monde')}
        </div>
        <Grid cols={4}>
          {[['pct_afrique','Afrique %'],['pct_amerique_nord','Amérique du Nord %'],
            ['pct_amerique_sud','Amérique du Sud %'],['pct_asie','Asie %']].map(([k,l])=>(
            <F key={k} label={l} value={data[k]} onChange={set(k)} type="number" placeholder="0" readOnly={readOnly}/>
          ))}
        </Grid>
        <Grid cols={3}>
          {[['pct_europe','Europe %'],['pct_oceanie','Océanie %'],['pct_antarctique','Antarctique %']].map(([k,l])=>(
            <F key={k} label={l} value={data[k]} onChange={set(k)} type="number" placeholder="0" readOnly={readOnly}/>
          ))}
        </Grid>
      </div>

      <div style={{ background:'#F8FAFC',borderRadius:8,padding:'12px 14px',marginBottom:12 }}>
        <div style={{ fontSize:12,fontWeight:700,color:'#475569',marginBottom:10,textTransform:'uppercase',letterSpacing:'.04em' }}>
          {t('collecte.reglement_title')}
        </div>
        <Grid cols={4}>
          {[['reglement_especes',t('collecte.reglement_especes')],
            ['reglement_cheque',t('collecte.reglement_cheque')],
            ['reglement_virement',t('collecte.reglement_virement')],
            ['reglement_carte',t('collecte.reglement_carte')]].map(([k,l])=>(
            <F key={k} label={l} value={data[k]} onChange={set(k)} type="number" placeholder="0" readOnly={readOnly}/>
          ))}
        </Grid>
        <div style={{ marginTop:8 }}>
          <YN label={t('collecte.passerelle_label')} value={data.passerelle_paiement||'non'}
            onChange={v=>setV('passerelle_paiement',v)} disabled={readOnly}/>
          {data.passerelle_paiement==='oui' && (
            <Grid cols={2} mt={6}>
              <F label={t('collecte.passerelle_nom')} value={data.passerelle_nom} onChange={set('passerelle_nom')} readOnly={readOnly}/>
              <F label={t('collecte.passerelle_delai')} value={data.passerelle_delai} onChange={set('passerelle_delai')} type="number" readOnly={readOnly}/>
            </Grid>
          )}
        </div>
      </div>

      {/* ── 7. PRÉVISIONNEL FINANCIER ──────────────────────── */}
      <Section label={t('collecte.section_previsionnel')}/>
      <Grid cols={2}>
        <F label={t('collecte.pct_acompte')} value={data.pct_acompte} onChange={set('pct_acompte')} type="number" placeholder="Ex. 30" readOnly={readOnly}/>
        <F label={t('collecte.mois_reservation')} value={data.mois_reservation} onChange={set('mois_reservation')} type="number" placeholder="Ex. 3" readOnly={readOnly}/>
      </Grid>
      <Grid cols={2}>
        <F label={t('collecte.mois_solde')} value={data.mois_solde} onChange={set('mois_solde')} type="number" placeholder="Ex. 1" readOnly={readOnly}/>
        <F label={t('collecte.montant_moyen')} value={data.montant_moyen_voyageur} onChange={set('montant_moyen_voyageur')} type="number" placeholder="Ex. 1500" readOnly={readOnly}/>
      </Grid>

      {/* Tableau prévisionnel avec auto-remplissage mois */}
      <div style={{ marginTop:14 }}>
        <div style={{ fontSize:13,fontWeight:700,marginBottom:4 }}>
          {t('collecte.previsionnel_title')}
        </div>
        <div style={{ fontSize:12,color:'#64748B',marginBottom:4,lineHeight:1.5 }}>
          {t('collecte.previsionnel_desc')}
        </div>
        {!readOnly && (
          <div style={{ background:'#EFF6FF',borderRadius:6,padding:'7px 12px',marginBottom:10,
            fontSize:12,color:'#1D4ED8',display:'flex',gap:7 }}>
            💡 {t('collecte.previsionnel_hint')}
          </div>
        )}

        <div style={{ border:'1px solid #E2E8F0',borderRadius:8,overflow:'hidden' }}>
          {/* Header */}
          <div style={{ display:'grid',gridTemplateColumns:'1fr 2fr',background:'#F8FAFC',
            padding:'9px 14px',fontSize:11,fontWeight:700,color:'#64748B' }}>
            <div>{t('collecte.previsionnel_col1')}</div>
            <div>{t('collecte.previsionnel_col2')}</div>
          </div>

          {previsionnel.map((row, i) => (
            <div key={i} style={{ display:'grid',gridTemplateColumns:'1fr 2fr',gap:8,
              padding:'7px 14px',borderTop:'1px solid #F8FAFC',
              background: i===0 ? '#FFFBF5' : 'transparent' }}>
              {/* Colonne 1 : sélecteur mois/année */}
              <div style={{ position:'relative' }}>
                {i === 0 && !readOnly ? (
                  <div>
                    <MonthPicker value={row.periode} onChange={handleFirstMonth} highlight={true}/>
                    <div style={{ fontSize:10,color:'#E8671A',marginTop:3 }}>↑ 1er mois — auto-remplissage</div>
                  </div>
                ) : (
                  <MonthPicker
                    value={row.periode}
                    onChange={v => { const a=[...previsionnel]; a[i]={...a[i],periode:v}; setV('previsionnel',a); }}
                    disabled={readOnly}
                  />
                )}
              </div>
              {/* Colonne 2 : montant */}
              <input type="number" value={row.montant||''} readOnly={readOnly}
                onChange={e=>setPrevMontant(i,e.target.value)} placeholder="0"
                style={readOnly?lockedStyle:{...inp,padding:'5px 8px',fontSize:13}}/>
            </div>
          ))}

          {/* Total */}
          <div style={{ display:'grid',gridTemplateColumns:'1fr 2fr',gap:8,
            padding:'9px 14px',borderTop:'2px solid #E2E8F0',background:'#F0FDF4' }}>
            <div style={{ fontSize:13,fontWeight:800,color:'#065F46' }}>
              {t('collecte.previsionnel_total')}
            </div>
            <div style={{ fontSize:14,fontWeight:800,color:'#059669' }}>
              {totalPrev.toLocaleString('fr-FR')} €
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
